export default function PHP_debug_backtrace() {
  return (
    <div>
      <h1>PHP_debug_backtrace</h1>
    </div>
  );
}
